{
  "version": 1,
  "asset_id": "0a491342-9fbd-42f8-9cb3-a8ef81ec6c30",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/0a491342-9fbd-42f8-9cb3-a8ef81ec6c30/svc-cro-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/0a491342-9fbd-42f8-9cb3-a8ef81ec6c30/svc-cro-640.webp",
  "original_filename": "svc-cro-640.webp",
  "size": 6142,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:46Z"
}
